"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_PICKER_VALUES = void 0;
const stats_1 = require("./stats");
/** Used mainly in the Sustainability Section on the home page of the portal */
exports.DATE_PICKER_VALUES = [...stats_1.STATS_PERIODS];
